<template>
  <div class="container users">
    <breadcrumb crumb="users" />
    <el-card>
      <el-row :gutter="24">
        <el-col :span="12" class="u_date">
          <span class="u_filter">По дате создания:</span>
          <el-date-picker
            v-model="date"
            placeholder="Введите дату создания"
            value-format="yyyy-MM-dd"
            @change="getUsers"
          />
        </el-col>
        <el-col :span="8" class="u_search">
          <div class="u_filter">Поиск:</div>
          <el-input
            v-model="search_input"
            placeholder="Введите для поиска"
            @keyup.enter.native="getUsers"
          >
            <el-button slot="append" icon="el-icon-search" @click="getUsers" />
            <el-button
              slot="prepend"
              icon="el-icon-close"
              @click="clearSearch"
            />
          </el-input>
        </el-col>
      </el-row>
      <el-table
        ref="tableData"
        v-loading="loading"
        :data="usersList"
        :span-method="spanMethod"
        style="width: 100%"
        row-class-name="u_row"
        @cell-click="cellClicked"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <user-info :props="props" />
          </template>
        </el-table-column>
        <el-table-column
          class-name="fio-class"
          label="ФИО"
          prop="fio"
          header-align="center"
          align="center"
        />
        <el-table-column
          label="Логин"
          prop="login"
          sortable
          header-align="center"
          align="center"
        />
        <el-table-column
          label="Тип пользователя"
          prop="user_type"
          sortable
          header-align="center"
          align="center"
        />
        <el-table-column
          label="Дата регистрации"
          prop="created_at"
          sortable
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ dateToFormat(usersList[scope.$index].created_at * 1000) }}
          </template>
        </el-table-column>
        <el-table-column label="Организации" header-align="right" :index="1">
          <template slot-scope="scope">
            <el-link
              v-for="(o, i) in usersList[scope.$index].organizations"
              :key="o.id"
              :underline="false"
              type="primary"
              class="users_org_p"
              @click="
                onLinkClick(
                  o,
                  usersList[scope.$index]['users-organizations'][i],
                )
              "
            >
              {{ o.short_name }}
              <i class="el-icon-view el-icon--right" />
            </el-link>
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template slot-scope="scope">
            <el-button
              data-goal="1"
              type="primary"
              icon="el-icon-search"
              class="no-events"
              circle
              @click.stop="setVisibleContragents(true, usersList[scope.$index])"
            />
            <el-button
              data-goal="1"
              type="danger"
              icon="el-icon-delete"
              class="no-events"
              circle
              @click.stop="beforeDelete(usersList[scope.$index].id)"
            />
          </template>
        </el-table-column>
        <el-table-column label="" />
      </el-table>
      <br /><br />
      <el-row :gutter="24">
        <el-col :span="18">&nbsp;</el-col>
        <el-col :span="6">
          <section class="bottom-section">
            <div class="pagination">
              <pagination-custom :data="pagination" @changed="changePage" />
            </div>
          </section>
        </el-col>
      </el-row>
    </el-card>
    <organization-modal
      :edit-org="editOrganization"
      :edited="toEdit"
      :documents="documents"
      :close-modal="closeModal"
      @change-ogrn-sourceId="changeOgrnSourceId"
      @change-inn-sourceId="changeInnSourceId"
    />
    <el-dialog
      title="Редактирование контрагента"
      :visible.sync="dialog_edit_contr"
      width="60%"
      center
      :close-on-click-modal="false"
    >
      <contragent-edit :contragent="edit_contr" />
    </el-dialog>

    <AddContragent
      :dialog-visible="dialogVisibleAddContragent"
      :current-user="currentUser"
      @close="setVisibleContragents(false, null)"
      @addContragentToUser="handleAddContragentToUser"
    />
  </div>
</template>

<script>
import { DELETE_USER } from '@/store/actions/users'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters, mapState } from 'vuex'
import AddContragent from '@/views/Contragents/modals/AddContragent'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import ContragentEdit from '@/components/Contragents/ContragentEdit'
import OrganizationModal from './components/OrganizationModal'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import UserInfo from './components/UserInfo'

const Users = RepositoryFactory.get('users')

export default {
  name: 'UsersList',
  components: {
    AddContragent,
    Breadcrumb,
    UserInfo,
    OrganizationModal,
    ContragentEdit,
    PaginationCustom,
  },
  data() {
    return {
      date: '',
      editOrganization: null,
      documents: {
        inn: {
          sourceModelName: 'userOrgs',
          sourceId: 0,
          documentType: 'inn',
        },
        ogrn: {
          sourceModelName: 'userOrgs',
          sourceId: 0,
          documentType: 'ogrn',
        },
      },
      dialog_edit_contr: false,
      edit_contr: {},
      search_input: '',
      curPage: 1,
      dialogVisibleAddContragent: false,
      currentUser: {},
    }
  },
  computed: {
    ...mapGetters({
      user: 'userProfile/getByKey',
      loading: 'users/getLoading',
      pagination: 'users/getPagination',
      usersList: 'users/getUsers',
    }),
    ...mapState('users', ['approvStatistics', 'loading']),
  },
  created() {
    this.getUsers()
  },
  methods: {
    changeOgrnSourceId(eventData) {
      this.documents.ogrn.sourceId = eventData.id
    },
    changeInnSourceId(eventData) {
      this.documents.inn.sourceId = eventData.id
    },
    formatDate(date) {
      return new Date(date * 1000).toLocaleDateString()
    },
    spanMethod({ columnIndex }) {
      if (columnIndex === 5) {
        return {
          rowspan: 1,
          colspan: 2,
        }
      }
    },
    clearSearch() {
      this.search_input = ''
      this.changePage()
    },
    changePage(page = 1) {
      this.curPage = page
      this.getUsers()
    },
    getUsers() {
      const search = {}
      const filterValue = String(this.search_input).trim()

      if (this.date) {
        search.registered_at = this.date
      }
      if (filterValue) {
        search.search = filterValue
      }
      this.$store.dispatch('users/fetchUsers', {
        page: this.curPage,
        search,
        flag: 1,
      })
    },
    cellClicked(row, column) {
      if (!column.index) {
        this.$refs.tableData.toggleRowExpansion(row)
      }
    },
    onLinkClick(org, userOrg) {
      org.userOrg = userOrg
      this.editOrganization = org
      this.documents.ogrn.sourceId = userOrg.id
      this.documents.inn.sourceId = userOrg.id
    },
    beforeClose() {
      this.editOrganization = null
      this.documents.ogrn.sourceId = 0
      this.documents.inn.sourceId = 0
    },
    beforeDelete(id = 0) {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      }).then(() => {
        Users.deleteUser(id).then(() => {
          this.$store.commit(`users/${DELETE_USER}`, { id })
          this.getUsers()
        })
      })
    },
    setVisibleContragents(val, user = {}) {
      this.currentUser = user
      this.dialogVisibleAddContragent = val
    },
    async handleAddContragentToUser({ user_id, contragent_id }) {
      if (user_id && contragent_id) {
        await Users.fillByContragent({
          user_id,
          contragent_id,
        })

        this.getUsers()
        this.dialogVisibleAddContragent = false
        this.currentUser = {}
      }
    },
    toEdit(contragent) {
      this.beforeClose()
      this.dialog_edit_contr = true
      this.edit_contr = contragent
    },
    closeModal() {
      this.editOrganization = null
    },
    editOrg(org) {
      this.editOrganization = org
    },
  },
}
</script>

<style lang="sass">
.users
  .el-card__body
    padding: 20px
    .fio-class .cell
      word-break: break-word
  .u_row
    cursor: pointer
  .users_org_p
    display: block
    margin: 0
    span:hover
      text-decoration: underline
  .u_filter
    margin-right: 10px
    white-space: nowrap
  .u_search
    display: flex
    align-items: center
    margin-bottom: 15px
    .el-input
      width: auto
  .u_date
    display: flex
    align-items: center
</style>
